var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.messages),function(msg,index){return (_vm.messages.length > 0)?_c('el-alert',{key:index,class:{'mb-2': _vm.lastIndex > index, 'mb-5': _vm.lastIndex == index},attrs:{"title":msg,"type":"error","show-icon":""}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }